/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Photo } from './';
import {
    PhotoFromJSON,
    PhotoFromJSONTyped,
    PhotoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserReference
 */
export interface UserReference {
    /**
     * The user account ID
     * @type {string}
     * @memberof UserReference
     */
    id: string;
    /**
     * User first name
     * @type {string}
     * @memberof UserReference
     */
    firstName: string;
    /**
     * User last name
     * @type {string}
     * @memberof UserReference
     */
    lastName: string;
    /**
     * 
     * @type {Photo}
     * @memberof UserReference
     */
    photo?: Photo;
}

/**
 * Check if a given object implements the UserReference interface.
 */
export function instanceOfUserReference(value: object): value is UserReference {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UserReferenceFromJSON(json: any): UserReference {
    return UserReferenceFromJSONTyped(json, false);
}

export function UserReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photo': json['photo'] == null ? undefined : PhotoFromJSON(json['photo']),
    };
}

export function UserReferenceToJSON(value?: UserReference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photo': PhotoToJSON(value['photo']),
    };
}

